export default __webpack_public_path__ + "static/media/icon-ai-search.a7f0e374.jpg";